function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from '@shared/components/spzaComponent';
import { isValidInput, serializeUserProfileEmbedInfo, readUserProfileEmbedCookie } from '@shared/utils/appUtils';
import { getCookieItem, saveCookieItem } from '@shared/utils/browserStorageUtils';
import { Constants, allBillingCountries } from '@shared/utils/constants';
import Animation from '@shared/components/animation';
import { getWindow } from '@shared/services/window';
import { logger } from '@src/logger';
import { Text, Stack, mergeStyleSets, TextField, Dropdown, Link } from '@fluentui/react';
export class UserProfileModalData {
    updateUserProfile(user, isEmbedHost, licenseType) {
        this.licenseType = licenseType;
        if (isEmbedHost && (user === null || user === void 0 ? void 0 : user.firstName) === '' && (user === null || user === void 0 ? void 0 : user.lastName) === '' && (user === null || user === void 0 ? void 0 : user.email) === '' && (user === null || user === void 0 ? void 0 : user.isLatestProfile) === false) {
            this.user = _object_spread_props(_object_spread({}, user), {
                phone: '',
                company: '',
                country: '',
                title: '',
                accepted: true
            });
            const userProfileInCookie = getCookieItem(Constants.userProfileEmbedCookieName, false);
            if (userProfileInCookie) {
                readUserProfileEmbedCookie(userProfileInCookie, this.user);
            } else {
                this.firstTimeEmbed = true;
            }
        } else {
            this.user = _object_spread_props(_object_spread({}, user), {
                accepted: true,
                licenses: this.setLicensesToLocalUserProfile(user.licenses)
            });
        }
    }
    setLicensesToLocalUserProfile(newLicenses) {
        if (this.licenseType !== Constants.Dynamics365LicenseType.noLicense && (newLicenses === null || newLicenses === void 0 ? void 0 : newLicenses.length) === Constants.dynamicsLicense.currentD365LicenseNumber) {
            const localLicenses = [];
            for(let i = 0; i < newLicenses.length; i++){
                const licenseInState = newLicenses[`${i}`];
                const licenseNewObj = {
                    type: licenseInState.type,
                    hasLicense: licenseInState.hasLicense,
                    isDisputed: licenseInState.isDisputed
                };
                localLicenses.push(licenseNewObj);
            }
            return localLicenses;
        }
        return [];
    }
    isDirty(originalUser) {
        for(const i in this.user){
            if (i !== 'accepted' && i !== 'licenses') {
                if (originalUser[`${i}`] !== this.user[`${i}`]) {
                    return true;
                }
            }
        }
        return false;
    }
    licenseChange(newCurrentLicense, isEmbeddedHost) {
        if (isEmbeddedHost) {
            return false;
        }
        if (newCurrentLicense && this.licenseType === Constants.Dynamics365LicenseType.dynamics365License && this.user.licenses[Constants.Dynamics365LicenseIndex.dynamics365LicenseIndex].isDisputed !== newCurrentLicense.isDisputed) {
            return true;
        }
        if (newCurrentLicense && this.licenseType === Constants.Dynamics365LicenseType.dynamics365forBusinessLicense && this.user.licenses[Constants.Dynamics365LicenseIndex.dynamics365ForBusinessLicenseIndex].isDisputed !== newCurrentLicense.isDisputed) {
            return true;
        }
        return false;
    }
    constructor(user, isEmbedHost, licenseType){
        _define_property(this, "user", void 0);
        _define_property(this, "firstTimeEmbed", void 0);
        _define_property(this, "licenseType", void 0);
        this.updateUserProfile(user, isEmbedHost, licenseType);
    }
}
const userProfileModalClassNames = mergeStyleSets({
    editButton: {
        paddingLeft: 3
    },
    boldText: {
        fontWeight: 600
    },
    doubleCellContainer: {
        [`@media (max-width: 425px)`]: {
            flexWrap: 'wrap'
        }
    },
    secondCell: {
        [`@media (min-width: 425px)`]: {
            marginLeft: 12
        },
        [`@media (max-width: 425px)`]: {
            marginTop: 15
        }
    }
});
const userProfileFieldsContainer = {
    childrenGap: 8
};
const expandedUserProfileTokens = {
    childrenGap: 21
};
const dropDownStyles = {
    callout: {
        maxHeight: 300,
        display: 'flex',
        flexDirection: 'column'
    }
};
export class UserProfileModal extends SpzaComponent {
    shouldProfileBeRendered() {
        const { renderProfile } = this.props;
        return renderProfile;
    }
    UNSAFE_componentWillMount() {
        const { profileCompleted, userLeadgenProfile, isEmbedded, licenseType } = this.props;
        if (!this.shouldProfileBeRendered()) {
            profileCompleted(true);
        } else {
            this.localUserInfo.updateUserProfile(userLeadgenProfile, isEmbedded, licenseType);
            this.checkMandatoryFields();
        }
    }
    onChange(id, value) {
        const { accountInfoUpdate } = this.props;
        this.localUserInfo.user[`${id}`] = value;
        accountInfoUpdate(id, value);
        this.checkMandatoryFields();
    }
    checkMandatoryFields() {
        const { profileCompleted } = this.props;
        profileCompleted(this.mandatoryFieldsDidUpdate());
    }
    mandatoryFieldsDidUpdate() {
        // TODO: Add validation for international phone numbers +52 353 333 7777
        // TODO: Validate phone number with code number.
        const { firstName, lastName, country } = this.localUserInfo.user;
        if (isValidInput(firstName) && isValidInput(lastName) && country && allBillingCountries.some((c)=>c.countryCode === this.localUserInfo.user.country)) {
            return true;
        }
        return false;
    }
    onClickEditButton(eventKeyCode) {
        const { shouldHideAccountInfo } = this.props;
        if (!eventKeyCode || eventKeyCode === Constants.SystemKey.Space || eventKeyCode === Constants.SystemKey.Enter) {
            this.setState((prevState)=>({
                    showProfile: true,
                    userProfileUpdated: prevState.userProfileUpdated
                }));
            shouldHideAccountInfo();
        }
    }
    renderCompactedUserProfile() {
        return /*#__PURE__*/ _jsx(Stack, {
            horizontal: true,
            children: /*#__PURE__*/ _jsx(Link, {
                className: userProfileModalClassNames.editButton,
                tabIndex: 0,
                role: "button",
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                onClick: (_)=>this.onClickEditButton(),
                onKeyDown: (event)=>this.onClickEditButton(event.keyCode),
                underline: true,
                children: this.context.loc('UserProfileCompacted_EditButton', 'Edit your details')
            })
        });
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { userLeadgenProfile: currentUserLeadgenProfile, isEmbedded, licenseType, userSubmittedForm: currenttUserSubmittedForm, updateUserProfile, callBackHandler } = this.props;
        const { userLeadgenProfile: nextUserLeadgenProfile, userSubmittedForm: nextUserSubmittedForm, currentLicense } = nextProps;
        if (!this.areEqual(currentUserLeadgenProfile, nextUserLeadgenProfile)) {
            this.localUserInfo.updateUserProfile(nextUserLeadgenProfile, isEmbedded, licenseType);
        }
        if (licenseType && licenseType !== Constants.Dynamics365LicenseType.noLicense && !this.licenseInfoEqual(this.localUserInfo.user.licenses, nextUserLeadgenProfile.licenses)) {
            this.localUserInfo.setLicensesToLocalUserProfile(nextUserLeadgenProfile.licenses);
        }
        if (nextUserSubmittedForm && nextUserSubmittedForm !== currenttUserSubmittedForm) {
            if (this.localUserInfo.isDirty(nextUserLeadgenProfile) || this.localUserInfo.licenseChange(currentLicense, isEmbedded) || nextUserLeadgenProfile.updateRequired) {
                if (!isEmbedded && licenseType && licenseType !== Constants.Dynamics365LicenseType.noLicense && this.localUserInfo.user.licenses && this.localUserInfo.user.licenses.length === Constants.dynamicsLicense.currentD365LicenseNumber) {
                    this.localUserInfo.user.licenses[licenseType - 1].isDisputed = currentLicense.isDisputed;
                }
                updateUserProfile(this.localUserInfo.user).then(()=>{
                    const payload = {
                        page: getWindow().location.href,
                        action: Constants.Telemetry.Action.Click,
                        actionModifier: Constants.Telemetry.ActionModifier.Info,
                        details: 'User Updated profile, Will run acquisition.'
                    };
                    logger.info(payload.details, {
                        action: payload.action,
                        actionModifier: payload.actionModifier
                    });
                    if (isEmbedded) {
                        saveCookieItem(Constants.userProfileEmbedCookieName, serializeUserProfileEmbedInfo(this.localUserInfo.user));
                    }
                    callBackHandler();
                });
            } else {
                const payload = {
                    page: getWindow().location.href,
                    action: Constants.Telemetry.Action.Click,
                    actionModifier: Constants.Telemetry.ActionModifier.Info,
                    details: 'User did not updated profile, Will run acquisition.'
                };
                logger.info(payload.details, {
                    action: payload.action,
                    actionModifier: payload.actionModifier
                });
                callBackHandler();
            }
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { compactUserProfile: currentCompactUserProfile, userLeadgenProfile: currentUserLeadgenProfile } = this.props;
        const { showProfile: currentShowProfile } = this.state;
        const { showProfile: nextShowProfile } = nextState;
        const { compactUserProfile: nextCompactUserProfile, userLeadgenProfile: nextUserLeadgenProfile } = nextProps;
        return currentShowProfile !== nextShowProfile || currentCompactUserProfile !== nextCompactUserProfile || !this.areEqual(nextUserLeadgenProfile, currentUserLeadgenProfile);
    }
    getDefaultCountry(defaultCountry) {
        const country = this.countryList.find((c)=>c.key === defaultCountry.toUpperCase());
        return country || {
            key: '',
            text: ''
        };
    }
    getCountries() {
        return allBillingCountries.map((c)=>({
                key: c.countryCode,
                text: c.name
            }));
    }
    dropDownCountry(defaultValue) {
        const id = Constants.Country;
        const selectedCountry = defaultValue ? this.getDefaultCountry(defaultValue) : {
            key: '',
            text: ''
        };
        const { key: selectedCountryKey } = selectedCountry;
        return /*#__PURE__*/ _jsx(Stack, {
            children: /*#__PURE__*/ _jsx(Dropdown, {
                options: this.countryList,
                label: this.context.loc('RT_Country', 'Country / region'),
                defaultSelectedKey: selectedCountryKey,
                onChange: (_, option)=>{
                    this.onChange(id, option.key.toString());
                },
                placeholder: this.context.loc('Leads_Modal_Country_Placeholder', 'Select country'),
                styles: dropDownStyles,
                disabled: !!selectedCountryKey,
                required: !selectedCountryKey
            })
        });
    }
    inputCell(field, className) {
        const { id, title, placeholder, defaultValue, isRequired } = field;
        return /*#__PURE__*/ _jsx(Stack.Item, {
            grow: true,
            children: /*#__PURE__*/ _jsx(TextField, {
                label: title,
                required: isRequired,
                onChange: (_, value)=>this.onChange(id, value),
                defaultValue: defaultValue || '',
                "aria-required": isRequired,
                ariaLabel: title,
                placeholder: placeholder,
                className: className
            }, id + defaultValue)
        });
    }
    doubleInputCells(isRequired, firstCell, secondCell, title) {
        const { id: firstCellId, defaultValue: firstCellDefaultValue, title: firstCellTitle, placeholder: firstCellPlaceholder } = firstCell;
        const { id: secondCellId, defaultValue: secondCellDefaultValue, title: secondCellTitle, placeholder: secondCellPlaceholder } = secondCell;
        return /*#__PURE__*/ _jsxs(Stack, {
            horizontal: true,
            className: userProfileModalClassNames.doubleCellContainer,
            children: [
                /*#__PURE__*/ _jsx(Stack.Item, {
                    grow: true,
                    children: /*#__PURE__*/ _jsx(TextField, {
                        required: isRequired,
                        label: title,
                        onChange: (_, value)=>this.onChange(firstCellId, value),
                        defaultValue: firstCellDefaultValue || '',
                        ariaLabel: firstCellTitle,
                        "aria-required": isRequired,
                        placeholder: firstCellPlaceholder
                    }, firstCellId + firstCellDefaultValue)
                }),
                /*#__PURE__*/ _jsx(Stack.Item, {
                    grow: true,
                    align: "end",
                    children: /*#__PURE__*/ _jsx(TextField, {
                        onChange: (_, value)=>this.onChange(secondCellId, value),
                        defaultValue: secondCellDefaultValue || '',
                        ariaLabel: secondCellTitle,
                        "aria-required": isRequired,
                        placeholder: secondCellPlaceholder,
                        className: userProfileModalClassNames.secondCell
                    }, secondCellId + secondCellDefaultValue)
                })
            ]
        });
    }
    renderExpandedHeader() {
        const { shouldRenderHeader, isContactForm, getExpandHeaderText } = this.props;
        const text = shouldRenderHeader && isContactForm ? this.context.loc('CTA_UserProfile_Title', "To continue, we need some basic profile information. We\u2019ve pulled your Microsoft Account data to help you get started.") : '';
        return /*#__PURE__*/ _jsx(Text, {
            variant: "medium",
            children: getExpandHeaderText || text
        });
    }
    renderExpandedUserProfile() {
        const { isEmbedded, userLeadgenProfile } = this.props;
        const firstName = {
            id: 'firstName',
            defaultValue: isEmbedded && !this.localUserInfo.user.firstName ? userLeadgenProfile.firstName : this.localUserInfo.user.firstName,
            title: this.context.loc('RT_FirstName', 'First name'),
            placeholder: this.context.loc('RT_FirstName', 'First name')
        };
        const lastName = {
            id: 'lastName',
            defaultValue: isEmbedded && !this.localUserInfo.user.lastName ? userLeadgenProfile.lastName : this.localUserInfo.user.lastName,
            title: this.context.loc('RT_LastName', 'Last name'),
            placeholder: this.context.loc('RT_LastName', 'Last name')
        };
        const title = {
            id: 'title',
            defaultValue: isEmbedded && !this.localUserInfo.user.title ? userLeadgenProfile.title : this.localUserInfo.user.title,
            title: this.context.loc('RT_Title', 'Job title'),
            placeholder: this.context.loc('Leads_Modal_Title_Placeholder', 'Enter your job title')
        };
        const company = {
            id: 'company',
            defaultValue: isEmbedded && !this.localUserInfo.user.company ? userLeadgenProfile.company : this.localUserInfo.user.company,
            title: this.context.loc('RT_Company', 'Company'),
            placeholder: this.context.loc('Leads_Modal_Company_Placeholder', 'Enter your company name')
        };
        const phone = {
            id: 'phone',
            defaultValue: isEmbedded && !this.localUserInfo.user.phone ? userLeadgenProfile.phone : this.localUserInfo.user.phone,
            title: this.context.loc('RT_Phone', 'Phone number'),
            placeholder: this.context.loc('Leads_Modal_Phone_Number_Placeholder', 'Write your phone number')
        };
        return /*#__PURE__*/ _jsxs(Stack, {
            tokens: expandedUserProfileTokens,
            children: [
                /*#__PURE__*/ _jsx(Stack.Item, {
                    children: this.renderExpandedHeader()
                }),
                /*#__PURE__*/ _jsxs(Stack, {
                    tokens: userProfileFieldsContainer,
                    children: [
                        this.doubleInputCells(true, firstName, lastName, this.context.loc('RT_Name', 'Name')),
                        /*#__PURE__*/ _jsxs(Stack, {
                            horizontal: true,
                            className: userProfileModalClassNames.doubleCellContainer,
                            children: [
                                this.inputCell(title),
                                this.inputCell(company, userProfileModalClassNames.secondCell)
                            ]
                        }),
                        this.dropDownCountry(isEmbedded && !this.localUserInfo.user.country ? userLeadgenProfile.country : this.localUserInfo.user.country),
                        this.inputCell(phone)
                    ]
                })
            ]
        });
    }
    renderAnimation() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "leadGen",
            children: [
                ' ',
                /*#__PURE__*/ _jsx(Animation, {}),
                ' '
            ]
        });
    }
    componentDidMount() {
        const { getUserProfile } = this.props;
        if (this.shouldGetUserProfile()) {
            getUserProfile();
        } else {
            this.checkMandatoryFields();
        }
    }
    shouldGetUserProfile() {
        const { userLeadgenProfile, isEmbedded } = this.props;
        return !userLeadgenProfile.isLatestProfile && this.shouldProfileBeRendered() && !isEmbedded;
    }
    shouldRenderExpandedProfile() {
        // if update required or one of the user props are not filled out.
        const { showProfile } = this.state;
        return showProfile || !this.mandatoryFieldsDidUpdate() || this.updateRequiredFromAPI();
    }
    updateRequiredFromAPI() {
        const { userLeadgenProfile } = this.props;
        return userLeadgenProfile.updateRequired === true;
    }
    renderImpl() {
        const { compactUserProfile } = this.props;
        if (compactUserProfile) {
            return this.renderCompactedUserProfile();
        } else if (!this.shouldProfileBeRendered()) {
            return null;
        } else if (this.shouldGetUserProfile()) {
            return this.renderAnimation();
        } else if (this.shouldRenderExpandedProfile()) {
            return this.renderExpandedUserProfile();
        } else {
            return this.renderCompactedUserProfile();
        }
    }
    componentDidUpdate(prevProps) {
        const { userLeadgenProfile: currentUserLeadgenProfile } = this.props;
        const { userLeadgenProfile: prevUserLeadgenProfile } = prevProps;
        if (!this.areEqual(prevUserLeadgenProfile, currentUserLeadgenProfile)) {
            this.checkMandatoryFields();
        }
    }
    areEqual(profile, newProfile) {
        return profile.isLatestProfile === newProfile.isLatestProfile && profile.updateRequired === newProfile.updateRequired && profile.firstName === newProfile.firstName && profile.lastName === newProfile.lastName && profile.company === newProfile.company && profile.country === newProfile.country && profile.phone === newProfile.phone && profile.title === newProfile.title && profile.email === newProfile.email;
    }
    licenseInfoEqual(license, newLicense) {
        if (!newLicense || !license) {
            return false;
        }
        if (license.length !== newLicense.length) {
            return false;
        }
        for(let i = 0; i < license.length; i++){
            if (license[`${i}`].isDisputed !== newLicense[`${i}`].isDisputed) {
                return false;
            }
        }
        return true;
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "countryList", this.getCountries()), _define_property(this, "localUserInfo", new UserProfileModalData(this.props.userLeadgenProfile, this.props.isEmbedded, this.props.licenseType));
        this.state = {
            showProfile: !!this.localUserInfo.firstTimeEmbed || !props.compactUserProfile,
            userProfileUpdated: false
        };
        this.onChange = this.onChange.bind(this);
    }
}
UserProfileModal.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    renderErrorModal: PropTypes.func
};
